import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';

import { Bau365DataAccessFairDataModule } from '@planone/bau365/data-access-fair-data';
import { Bau365UtilKeycloakModule } from '@planone/bau365/util-keycloak';

import { RestrictedAccessEffects } from './state/restricted-access.effects';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([RestrictedAccessEffects]),
    Bau365DataAccessFairDataModule,
    Bau365UtilKeycloakModule,
  ],
})
export class Bau365FeatureRestrictedAccessModule {}
